import { render, staticRenderFns } from "./OnboardingDocumentsCamera.vue?vue&type=template&id=903720f8&scoped=true"
import script from "./OnboardingDocumentsCamera.vue?vue&type=script&lang=js"
export * from "./OnboardingDocumentsCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903720f8",
  null
  
)

export default component.exports